module.exports = __webpack_public_path__ + "static/www/img/logo1.b8d5e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/training/fixnav/assets/logo1.png
// module id = 371
// module chunks = 1